import Logo from 'components/v2/atoms/logo';
import FooterLinks from 'components/v2/modules/about-lp/footer-links';

const AboutPageFooter = () => {
  return (
    <footer className="all-font-sans border-t border-pp-border-primary bg-pp-bg-secondary py-20">
      <div className="mx-auto max-w-screen-xl px-5 lg:px-10">
        <div className="mb-10 flex flex-col items-start justify-between gap-16 lg:flex-row lg:items-center">
          <div className="max-w-2xl flex-1">
            <Logo className="mb-3" href="/about" />
            <p className="text-sm leading-relaxed text-pp-text-secondary">
              PostPrime株式会社は「お金」にまつわる情報交換ができるコミュニティを提供しています。利用ユーザはライブ配信・動画・音声・その他の投稿で専門家から投資のことを学ぶことができます。また、過去のチャートパターンとテクニカル分析を学習したAIを取り入れることにより、マーケットの評価など様々な分析機能を使うことができます。
            </p>
          </div>

          <div className="lg:self-center">
            <FooterLinks />
          </div>
        </div>

        <div className="border-t border-pp-border-primary pt-10 text-center">
          <p className="text-sm text-pp-text-tertiary">
            © 2025 PostPrime Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default AboutPageFooter;
